import {Stack, styled} from '@mui/material'

export const StatsWrapper = styled(Stack)(({theme}) => ({
  flexDirection: 'row',
  gap: '1rem',
  justifyContent: 'space-evenly',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}))

export const StatsItemWrapper = styled(Stack)(() => ({
  flex: 1,
}))
